import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { useUserStore, usePageStore } from '@/store';


import signLog from '@/components/sign-log';
import { getSnapshotListing } from '../../api';
import { currencyFormat } from '@/common/format';
export default {
    i18next: {
        ns: 'md-listing-list'
    },
    computed: {

        ...rootMapState(usePageStore, {
            "page": store => store.page || {},
            "currencySymbol": store => store.currency?.symbol
        }),

        ...rootMapState(useUserStore, {
            "user": store => store.user
        }),

        ...mapState({
            "soldListingInfo": store => store.soldListingInfo,
            "showRecentListingNoData": "showRecentListingNoData",
            "showRecentListingNoLocation": "showRecentListingNoLocation"
        }),
        
        
        
        showLock() {
            return (
                !this.user &&
                !this.showRecentListingNoLocation &&
                !this.showRecentListingNoData &&
                !this.soldAvgText
            );
        },
        soldAvgText() {
            const { statResultList, paramKey } = this;

            if (paramKey && statResultList && Array.isArray(statResultList)) {
                let soldPrice = statResultList.find(
                    item => item.key === 'soldPrice'
                );
                let pricePerSqft = statResultList.find(
                    item => item.key === 'pricePerSqft'
                );
                let res1, res2;
                if (soldPrice) {
                    res1 = Number(soldPrice.avg)
                        ? currencyFormat(soldPrice.avg, false, 0, this.currencySymbol)
                        : false;
                }
                if (pricePerSqft) {
                    res2 = Number(pricePerSqft.avg)
                        ? currencyFormat(pricePerSqft.avg, false, 0, this.currencySymbol)
                        : false;
                }
                if (res1 && res2) {
                    return this.$t('md-listing-list.homesInParamskeyAverage', {
                        key: paramKey,
                        res1,
                        res2
                    });
                } else if (res1) {
                    return this.$t('md-listing-list.homesInParamskeyAverage0', {
                        key: paramKey,
                        res1
                    });
                } else if (res2) {
                    return this.$t('md-listing-list.homesInParamskeyAverage1', {
                        key: paramKey,
                        res2
                    });
                }
            }
            return '';
        }
    },
    data: function() {
        return {
            statResultList: null,
            paramKey: null
        };
    },
    created() {
        this.getPriceAvg();
    },
    methods: {
        showRegisterPop() {
            signLog.register();
        },
        async getPriceAvg() {
            if (!this.soldListingInfo) {
                return; 
            }
            let { city, state, zipCode } = this.soldListingInfo.info;
            let params = {
                'sold-date': 180,
                key: '',
                keywordType: '',
                includeStat: true,
                listingStatus: 'Sold'
            };
            if (city && state) {
                params.keywordType = 'city';
                params.key = `${city}, ${state}`;
            } else if (zipCode) {
                params.keywordType = 'zipCode';
                params.key = zipCode;
            } else {
                params = null;
                console.log(
                    'Exception: current page is sold-house,but has not city&state or zipCode.'
                );
            }
            if (!params) {
                return; 
            }
            let {
                statsResults: { statResultList } = {}
            } = await getSnapshotListing.call(this, params, this.page);
            this.statResultList = statResultList;
            this.paramKey = params.key;
        }
    }
};
